import { Routes } from '@angular/router';
import { canDeactivateGuard } from '../../shared/guards/can-deactivate.guard';
import { Roles } from '../../shared/enums/roles.enum';
import { roleGuard } from '../../shared/guards/role.guard';

export const countryRoutes: Routes = [
  {
    path: 'messages',
    data: {
      breadcrumb: 'administration.countries.breadcrumb.messagesLabel',
    },
    loadComponent: () =>
      import('./country-messages/country-messages.component').then(
        (m) => m.CountryMessagesComponent
      ),
  },
  {
    path: 'messages-details',
    loadComponent: () =>
      import('./country-messages/details/country-messages-details.component').then(
        (m) => m.CountryMessagesDetailsComponent
      ),
  },
  {
    path: 'messages-details/:id',
    loadComponent: () =>
      import('./country-messages/details/country-messages-details.component').then(
        (m) => m.CountryMessagesDetailsComponent
      ),
  },
  {
    path: 'general-settings',
    data: {
      roles: [Roles.SUPER_USER, Roles.ADMIN_COUNTRY],
      breadcrumb: 'administration.countries.tabs.generalSettings.tabLabel',
    },
    canActivate: [roleGuard],
    loadComponent: () =>
      import('./country-general-settings/country-general-settings.component').then(
        (m) => m.CountryGeneralSettingsComponent
      ),
    canDeactivate: [canDeactivateGuard],
  },
  {
    path: 'vat-compliant-bordereau',
    data: {
      roles: [Roles.SUPER_USER],
      breadcrumb:
        'administration.countries.tabs.vatCompliantBordereau.tabLabel',
    },
    canActivate: [roleGuard],
    loadComponent: () =>
      import('./country-vat-compliant-bordereau/country-vat-compliant-bordereau.component').then(
        (m) => m.CountryVatCompliantBordereauComponent
      ),
  },
  {
    path: 'help-documents',
    data: {
      breadcrumb: 'administration.countries.breadcrumb.helpDocumentsLabel',
    },
    loadComponent: () =>
      import('./country-help-documents/country-help-documents.component').then(
        (m) => m.CountryHelpDocumentsComponent
      ),
  },
  {
    path: 'help-documents-details',
    loadComponent: () =>
      import('./country-help-documents/details/country-help-documents-details/country-help-documents-details.component').then(
        (m) => m.CountryHelpDocumentsDetailsComponent
      ),
  },
  {
    path: 'payment-details',
    data: {
      breadcrumb: 'administration.countries.tabs.paymentDetails.tabLabel',
    },
    loadComponent: () =>
      import('./country-payment-details/country-payment-details.component').then(
        (m) => m.CountryPaymentDetailsComponent
      ),
  },
];
